<template>
  <div class="error-page bg-blue">
    <app-header :isSearchBar="isSearchBar" :headerColor="headerColor"/>

    <div class="app-body bg-blue">
      <div class="app-body_show container-fluid">
        <div class="row">
          <div class="col-md-5 t-white">
            <h1 class="t-600 t-xlr t-white mb-4">Oops! You're not able to do this action.</h1>
            <h2 class="t-white t-md mb-0">
              Sorry, looks like you do not have the authorization to do this.
              <br />Try refreshing the page before continuing or log in.
            </h2>

            <p class="t-600 mt-4 mb-2">Get back on track:</p>
            <div class="cta-group">
              <router-link :to="{ name: 'searchHome'}" class="btn btn-secondary">
                <span class="t-sm t-600 t-white">Search</span>
              </router-link>
              <router-link v-if="$currentUser" :to="{ name: 'researcher.show', params: { id: $currentUser.slug_values[0] } }" class="btn btn-secondary">
                <span class="t-sm t-600 t-primary">My Profile</span>
              </router-link>
              <router-link v-else :to="{ name: 'login'}" class="btn btn-secondary">
                <span class="t-sm t-600 t-primary">Log in or Sign up</span>
              </router-link>
            </div>

            <p class="t-sm pt-5 mt-5 report">
              If this problem continues and you think something is wrong, please <a href="mailto:support@academiclabs.com" target="_blank" rel="noopener noreferrer" class="t-white">send us a report</a>.
            </p>

          </div>

          <div class="col-md-7">
            <icon :icon="`welcome-image`" class="w-100"></icon>
          </div>
        </div>
      </div>
    </div>

    <app-footer class="t-white" />
  </div>
</template>

<script>
import AppHeader from '@/components/shared/header/AppHeader'
import AppFooter from '@/components/shared/footer/AppFooter'
import Icon from '@/components/shared/Icon'

export default {
  name: 'error401',
  components: {
    AppHeader,
    AppFooter,
    Icon
  },
  metaInfo () {
    return {
      titleTemplate: `401 Not Authorized | AcademicLabs`
    }
  },
  data () {
    return {
      isSearchBar: false,
      headerColor: 'bg-blue'
    }
  }
}
</script>
